import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate, useLocation } from 'react-router-dom';
import { useGame } from '../../context/GameContext';
import { logout } from '../../api';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiHome, FiMap, FiUser, FiLogOut, FiShield } = FiIcons;

function NavigationBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { state, dispatch } = useGame();

  const isWelcomeScreen = location.pathname === '/';
  const isGameScreen = location.pathname.includes('/game/');
  const isAuthScreen = ['/login', '/signup'].includes(location.pathname);
  const isParentDashboard = location.pathname === '/parent';

  if (isWelcomeScreen || isGameScreen || isAuthScreen || isParentDashboard) return null;

  const navItems = [
    { id: 'home', icon: FiHome, label: 'Home', path: '/dashboard', color: 'from-jungle-500 to-jungle-600' },
    { id: 'quest-map', icon: FiMap, label: 'Quest Map', path: '/quest-map', color: 'from-safari-500 to-safari-600' },
    { id: 'profile', icon: FiUser, label: 'Profile', path: '/profile', color: 'from-purple-500 to-purple-600' },
    { id: 'parent', icon: FiShield, label: 'Parent', path: '/parent', color: 'from-indigo-500 to-indigo-600' },
  ];

  const handleLogout = () => {
    logout();
    dispatch({ type: 'LOGOUT' });
    navigate('/');
  };

  return (
    <motion.div initial={{ y: -100 }} animate={{ y: 0 }}
      className="fixed top-4 left-1/2 transform -translate-x-1/2 z-50 w-auto">
      <div className="bg-white/90 backdrop-blur-md rounded-3xl px-4 py-3 shadow-2xl border-4 border-safari-200 flex items-center space-x-2">
        <div className="flex items-center space-x-2 bg-gradient-to-r from-yellow-400 to-yellow-500 text-white px-3 py-2 rounded-2xl">
          <span className="text-lg">🪙</span>
          <span className="font-kid text-sm">{state.tokens || 0}</span>
        </div>
        <div className="flex items-center space-x-1">
          {navItems.map((item) => (
            <motion.button key={item.id} whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.9 }}
              onClick={() => navigate(item.path)}
              aria-label={item.label}
              title={item.label}
              className={`p-3 rounded-2xl text-white shadow-lg transition-all duration-200 ${location.pathname === item.path
                ? `bg-gradient-to-r ${item.color} scale-110 shadow-xl`
                : 'bg-gray-400 hover:bg-gray-500'}`}>
              <SafeIcon icon={item.icon} className="text-xl" />
            </motion.button>
          ))}
        </div>
        <div className="hidden md:flex items-center space-x-2 bg-jungle-100 px-3 py-2 rounded-xl">
          <span className="text-xs font-comic text-jungle-700">Lvl</span>
          <span className="font-kid text-jungle-700">{state.level}</span>
        </div>
        <motion.button whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.9 }}
          onClick={handleLogout}
          aria-label="Logout"
          className="p-3 rounded-2xl bg-red-400 hover:bg-red-500 text-white shadow-lg transition-all">
          <SafeIcon icon={FiLogOut} className="text-xl" />
        </motion.button>
      </div>
    </motion.div>
  );
}

export default NavigationBar;